import React, { useEffect, useState } from "react";
import { Column } from "devextreme-react/data-grid";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { createUser, deleteUser, getUsersWithRoles, updateUser } from "../../redux/users/thunks";
import { getRoles } from "../../redux/roles/thunks";
import { selectUsersLoading, selectUsersPag } from "../../redux/users/selectors";
import { selectRoles, selectRolesLoading } from "../../redux/roles/selectors";
import { openModal } from "../../redux/modal/modalSlice";

const initialSortOptions = {
    columna: "userId",
    sortOrderAsc: true

}

function UserManagement() {
    const dispatch = useDispatch();
    const users = useSelector(selectUsersPag);
    const roles = useSelector(selectRoles);
    const usersLoading = useSelector(selectUsersLoading);
    const rolesLoading = useSelector(selectRolesLoading);
    const loading = (usersLoading === "loading" || rolesLoading === "loading")? "loading" : "succeeded";
    const numElements = [10, 20, 30];
    const [sortOptions, setSortOptions] = useState(initialSortOptions)

    useEffect(() => {
        getUsers(mapPageInfo(users));
        dispatch(getRoles());
    }, [])

    function mapPageInfo(users) {
        return {
            pageIndex: users.pageIndex ?? 0,
            pageSize: users.pageSize ?? 10,
            orderByField:  users.columna ?? "userId",
            orderByAscending:  users.sortOrderAsc ?? true
        }
    }

    const getUsers = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getUsersWithRoles({ query }));
    }

    const handleSaveNew = (userForm, closeDialog) => {
        if (userForm.userName !== "" && userForm.roles.length > 0) {
            const params = {
                body: {
                    UserName: userForm.userName,
                    Roles: userForm.roles
                }
            }
            dispatch(createUser(params)).then((data) => {
                if (data.error)
                    dispatch(openModal({ type: "warning", message: data.error.message }))
                else {
                    getUsers(mapPageInfo({...users,...sortOptions}));
                    closeDialog();
                }
            })
        } else {
            closeDialog();
        }
    }

    const handleSaveEdit = (userForm, closeDialog) => {
        if (userForm.userName !== "" && userForm.roles.length > 0) {
            const params = {
                body: {
                    UserName: userForm.userName,
                    Roles: userForm.roles
                },
                param: userForm.userId
            }
            dispatch(updateUser(params)).then((data) => {
                if (data.error)
                    dispatch(openModal({ type: "warning", message: data.error.message }))
                else {
                    getUsers(mapPageInfo({...users,...sortOptions}));
                    closeDialog();
                }
            })
        } else {
            closeDialog();
        }
    }

    const handleDelete = (userId, closeDialog) => {
        dispatch(deleteUser({ param: userId })).then((data) => {
            if (data.error)
                dispatch(openModal({ type: "warning", message: data.error.message }))
            else {
                let updatedPageIndex = users.pageIndex;

                if (users.elements.length === 1) {
                    updatedPageIndex = Math.max(0, users.pageIndex - 1);
                }

                const updatedUsers = {
                    ...users,
                    pageIndex: updatedPageIndex,
                };

                getUsers(mapPageInfo({...users,...sortOptions}));
                closeDialog()
            }
        })
    }

    const handleCalculateRoleCellDisplayValue = (rowData) => {
        return rowData.roles.map(role => role.roleDescription).join(", ");
    }

    const columnsTaxonomy = [
        <Column allowEditing={false} key={"users-1"} dataField = "userId" caption="Id" />,
        <Column key={"users-2"} dataField = "userName" caption="Nome de usuário" />,
        <Column key={"users-3"} lookup={{multiple: true, allowClearing: false, dataSource: roles, displayExpr:'roleDescription', valueExpr:'roleId'}} dataField = "roles" calculateDisplayValue={handleCalculateRoleCellDisplayValue} caption="Roles" />,
    ]

    return (
        <div style={{width: "100%"}}>
            <AdminTable 
                defaultSortField={"userId"}
                sectionTitle={"Usuários"}
                masterTitle={"Usuários"} 
                itemIdField={"userId"} 
                itemDescriptionField={"userName"} 
                loading={loading} 
                dataSource={users} 
                columnasTabla={columnsTaxonomy} 
                numElements={numElements} 
                getData = { getUsers } 
                onCreate={handleSaveNew} 
                onEdit={handleSaveEdit} 
                onDelete={handleDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
                />
        </div>
    )
}

export default UserManagement
